export default __webpack_public_path__ + "static/3-d2296f57213807524b60011deb6d40c1.jpg";